var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-pdf-app',{staticStyle:{"height":"100vh"},attrs:{"pdf":_vm.file,"config":_vm.config,"isSidebarHidden":"false"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }